import { I18n } from '@calendly/i18n'

export const BASIC = 'basic'
export const STANDARD = 'standard'
export const STANDARD_SCHEDULING = 'standard_scheduling'
export const STANDARD_NOTETAKER = 'standard_notetaker'
export const TEAMS = 'teams'
export const TEAMS_SCHEDULING = 'teams_scheduling'
export const TEAMS_NOTETAKER = 'teams_notetaker'
export const ENTERPRISE = 'enterprise'

const getBasicTierContent = () => ({
  tierName: I18n.t('publisher.billing.tiers.basic'),
  tierShortName: I18n.t('publisher.billing.tiers.basic'),
  order: 1,
  seatCount: '1',
  alwaysFree: I18n.t('publisher.billing.price.basic.always_free'),
  price: {
    USD: {
      month: '$0',
      year: '$0'
    },
    AUD: {
      month: 'A$0',
      year: 'A$0'
    },
    BRL: {
      month: 'R$\u00A00',
      year: 'R$\u00A00'
    },
    EUR: {
      month: '€0',
      year: '€0'
    },
    GBP: {
      month: '£0',
      year: '£0'
    },
    INR: {
      month: '₹0',
      year: '₹0'
    }
  }
})

const rawGetTierMap = (audVariant) => {
  const AUD_PRICING_VARIANTS = {
    variant_1: {
      standard: {
        month: 'A$18',
        year: 'A$15'
      },
      teams: {
        month: 'A$30',
        year: 'A$24'
      }
    },
    variant_2: {
      standard: {
        month: 'A$16',
        year: 'A$13'
      },
      teams: {
        month: 'A$26',
        year: 'A$20'
      }
    }
  }

  const STANDARD_CONTENT = {
    tierName: I18n.t('publisher.billing.tiers.standard'),
    tierShortName: I18n.t('publisher.billing.tiers.standard'),
    description: I18n.t('publisher.billing.plan_selection.plan_descriptions.p_and_p_20.standard'),
    notetaker_downgrade_description: I18n.t('publisher.billing.plan_selection.plan_descriptions.notetaker_downgrade.standard'),
    order: 2,
    price: {
      USD: {
        month: '$12',
        year: '$10'
      },
      AUD: AUD_PRICING_VARIANTS[audVariant]?.standard || {
        month: 'A$18',
        year: 'A$15'
      },
      BRL: {
        month: 'R$\u00A059,90',
        year: 'R$\u00A049,90'
      },
      EUR: {
        month: '€12',
        year: '€10'
      },
      GBP: {
        month: '£10',
        year: '£8'
      },
      INR: {
        month: '₹649',
        year: '₹499'
      }
    },
    priceText: {
      USD: I18n.t('publisher.billing.price.cost_per_month'),
      AUD: I18n.t('publisher.billing.price.cost_per_month'),
      EUR: I18n.t('publisher.billing.price.cost_per_month'),
      GBP: I18n.t('publisher.billing.price.cost_per_month'),
      INR: I18n.t('publisher.billing.price.cost_per_month'),
      BRL: I18n.t('publisher.billing.price.cost_per_month')
    },
    features: {
      categories: [{
        key: 'scheduling',
        name: I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.name'),
        features: [
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.event_types'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.calendars'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.marketing_integrations'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.payment_integrations'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.automations'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.reminders'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.outreach'),
          I18n.t('publisher.billing.plan_selection.card_features.standard.scheduling.chat_support')
        ]
      }]
    }
  }

  const TEAMS_CONTENT = {
    tierName: I18n.t('publisher.billing.tiers.teams'),
    tierShortName: I18n.t('publisher.billing.tiers.teams'),
    description: I18n.t('publisher.billing.plan_selection.plan_descriptions.p_and_p_20.teams'),
    order: 3,
    price: {
      USD: {
        month: '$20',
        year: '$16'
      },
      AUD: AUD_PRICING_VARIANTS[audVariant]?.teams || {
        month: 'A$30',
        year: 'A$24'
      },
      BRL: {
        month: 'R$\u00A099,90',
        year: 'R$\u00A079,90'
      },
      EUR: {
        month: '€20',
        year: '€16'
      },
      GBP: {
        month: '£17',
        year: '£13'
      },
      INR: {
        month: '₹999',
        year: '₹699'
      }
    },
    priceText: {
      USD: I18n.t('publisher.billing.price.cost_per_month'),
      AUD: I18n.t('publisher.billing.price.cost_per_month'),
      EUR: I18n.t('publisher.billing.price.cost_per_month'),
      GBP: I18n.t('publisher.billing.price.cost_per_month'),
      INR: I18n.t('publisher.billing.price.cost_per_month'),
      BRL: I18n.t('publisher.billing.price.cost_per_month')
    },
    features: {
      preface: I18n.t('publisher.billing.plan_selection.card_features.teams.preface'),
      categories: [{
        key: 'scheduling',
        name: I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.name'),
        features: [
          I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.salesforce'),
          I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.round_robin'),
          I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.routing'),
          I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.marketing_integrations'),
          I18n.t('publisher.billing.plan_selection.card_features.teams.scheduling.admin')
        ]
      }, {
        name: I18n.t('publisher.billing.plan_selection.card_features.teams.security_addon.name'),
        key: 'security_addon',
        features: [
          I18n.t('publisher.billing.plan_selection.card_features.teams.security_addon.sso')
        ]
      }]
    }
  }

  const ENTERPRISE_CONTENT = {
    tierName: I18n.t('publisher.billing.tiers.enterprise'),
    tierShortName: I18n.t('publisher.billing.tiers.enterprise'),
    description: I18n.t('publisher.billing.plan_selection.plan_descriptions.p_and_p_20.enterprise'),
    order: 4,
    startsAt: {
      USD: I18n.t('publisher.billing.price.enterprise.starts_at')
    },
    price: {
      USD: {
        month: '$15k',
        year: '$15k'
      },
      AUD: {
        month: I18n.t('publisher.billing.price.enterprise.lets_chat'),
        year: I18n.t('publisher.billing.price.enterprise.lets_chat')
      },
      BRL: {
        month: I18n.t('publisher.billing.price.enterprise.lets_chat'),
        year: I18n.t('publisher.billing.price.enterprise.lets_chat')
      },
      EUR: {
        month: I18n.t('publisher.billing.price.enterprise.lets_chat'),
        year: I18n.t('publisher.billing.price.enterprise.lets_chat')
      },
      GBP: {
        month: I18n.t('publisher.billing.price.enterprise.lets_chat'),
        year: I18n.t('publisher.billing.price.enterprise.lets_chat')
      },
      INR: {
        month: I18n.t('publisher.billing.price.enterprise.lets_chat'),
        year: I18n.t('publisher.billing.price.enterprise.lets_chat')
      }
    },
    priceText: {
      USD: I18n.t('publisher.billing.price.cost_per_year')
    },
    features: {
      preface: I18n.t('publisher.billing.plan_selection.card_features.enterprise.preface'),
      categories: [{
        key: 'scheduling',
        name: I18n.t('publisher.billing.plan_selection.card_features.enterprise.scheduling.name'),
        features: [
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.scheduling.salesforce_routing'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.scheduling.dynamics'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.scheduling.support')
        ]
      }, {
        key: 'security',
        name: I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.name'),
        features: [
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.sso'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.domain_control'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.audit_log'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.deletion_api'),
          I18n.t('publisher.billing.plan_selection.card_features.enterprise.security.security_legal')
        ]
      }]
    }
  }

  const tierContent = {
    [STANDARD]: STANDARD_CONTENT,
    [TEAMS]: TEAMS_CONTENT,
    [ENTERPRISE]: ENTERPRISE_CONTENT
  }

  return { tierContent }
}

const cache = {}

export const getTierMap = ({
  isBasicTierVisible = false,
  audVariant = 'variant_1'
} = {}) => {
  const cacheKey = `${isBasicTierVisible}`
  if (cacheKey in cache) return cache[cacheKey]

  const result = rawGetTierMap(audVariant)

  if (isBasicTierVisible) {
    result.tierContent = {
      ...result.tierContent,
      [BASIC]: getBasicTierContent()
    }
  }

  cache[cacheKey] = result

  return result
}
